// botService.js
import axios from "axios";

// Get all bots
export const getAllBots = async () => {
	try {
		const response = await axios.get("/api/bots");
		return response.data.bots;
	} catch (error) {
		console.error("Error fetching bots:", error);
		throw error;
	}
};

// Get a single bot by ID
export const getBotById = async (id) => {
	try {
		const response = await axios.get(`/api/bots/${id}`);

		// Fetch permissions for this bot specifically
		try {
			const permResponse = await axios.get(`/api/bots/${id}/permissions`);
			if (permResponse.data.success && permResponse.data.permissions) {
				// Add permissions to the bot object
				response.data.bot.permissions = permResponse.data.permissions;
			}
		} catch (permError) {
			console.warn("Could not fetch bot permissions:", permError);
		}

		return response.data.bot;
	} catch (error) {
		console.error("Error fetching bot details:", error);
		throw error;
	}
};

// Create a new bot
export const createBot = async (formData) => {
	const response = await axios.post("/api/bots", formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response.data.bot;
};

// Delete a bot
export const deleteBot = async (id) => {
	const response = await axios.delete(`/api/bots/${id}`);
	return response.data;
};

// Start a bot
export const startBot = async (id) => {
	const response = await axios.post(`/api/bots/${id}/start`);
	return response.data;
};

// Stop a bot
export const stopBot = async (id) => {
	const response = await axios.post(`/api/bots/${id}/stop`);
	return response.data;
};

// Restart a bot
export const restartBot = async (id) => {
	const response = await axios.post(`/api/bots/${id}/restart`);
	return response.data;
};

// Install packages for a bot
export const installPackages = async (id) => {
	const response = await axios.post(`/api/bots/${id}/install`);
	return response.data;
};

// Get bot status
export const getBotStatus = async (id) => {
	const response = await axios.get(`/api/bots/${id}/status`);
	return response.data.status;
};

// Check bot permissions
export const getBotPermissions = async (id) => {
	try {
		const response = await axios.get(`/api/bots/${id}/permissions`);
		return response.data;
	} catch (error) {
		console.error("Error fetching bot permissions:", error);
		return {
			success: false,
			permissions: [],
			can_view: false,
			can_start: false,
			can_stop: false,
		};
	}
};

// Tambahkan ke botService.js
// Request bot access (for non-admin users)
export const requestBotAccess = async (requestData) => {
	try {
		const response = await axios.post("/api/bot-requests", requestData);
		return response.data;
	} catch (error) {
		console.error("Error requesting bot access:", error);
		throw error;
	}
};
